/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {i18n} from '../../../../translate/i18n'
import {Loading} from '../../../../components/Loading/Loading'
import {AdditionalListType} from '../../../../context/additionalContext'
import Swal from 'sweetalert2'
import {DELETE, GET} from '../../../../services/api'

const OpcionaisContent: FC = () => {
  const [additionals, setAdditionals] = useState<AdditionalListType[]>([])
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const callAdditionals = async () => {
    const responseAdditionals = await GET('optional/list-admin')
    if (responseAdditionals.success) {
      setAdditionals(responseAdditionals.data)
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: responseAdditionals.data ? responseAdditionals.data : 'Erro ao obter adicionais',
      })
    }
  }

  const deleteAdditional = async (id: number) => {
    try {
      const deletedAddional = await DELETE(`optional/additional/${id}`)
      if (deletedAddional.success) {
        Swal.fire({
          title: 'Sucesso!',
          text: 'Lista apagada com sucesso.',
          icon: 'success',
        }).then(async () => await init())
      } else {
        Swal.fire({
          title: 'Erro!',
          text: 'Erro ao deletar lista de adicionais.',
          icon: 'error',
        })
      }
    } catch (e) {
      Swal.fire({
        title: 'Erro!',
        text: 'Erro ao deletar lista de adicionais.',
        icon: 'error',
      })
    }
  }

  const init = async () => {
    setLoading(true)
    await callAdditionals()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5 justify-content-between'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`optional.list`)}</span>
              </h3>
              <div className='mt-4'>
                <Button
                  text={i18n.t('optional.create')}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/optionals/create')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={additionals}
                headers={[
                  {key: 'ID', value: 'id', type: 'default'},
                  {key: i18n.t(`optional.name`), value: 'name', type: 'default'},
                  {
                    key: i18n.t(`optional.used`),
                    value: 'qtdProducts',
                    type: 'tooltip',
                    products: 'products',
                  },
                  {key: 'Ações', value: 'acoes', type: '', noOrder: true},
                ]}
                options={[
                  {
                    isButton: true,
                    textButton: i18n.t('optional.link'),
                    icon: '',
                    href: `/optionals/id/edit`,
                    title: i18n.t('optional.link'),
                    action: (item) => {
                      window.open(`/optionals/${item.id}/associate`, '_blank', 'noreferrer')
                    },
                  },
                  {
                    isButton: true,
                    textButton: i18n.t('optional.config'),
                    icon: '',
                    href: `/optionals/id/edit`,
                    title: i18n.t('optional.config'),
                    action: (item) => {
                      window.open(`/optionals/${item.id}/edit`, '_blank', 'noreferrer')
                    },
                  },
                  {
                    icon: 'fas fa-trash',
                    action: async (item) => {
                      Swal.fire({
                        title: 'Você tem certeza?',
                        text: 'Deseja realmente deletar essa lista?',
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Deletar',
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          setLoading(true)
                          await deleteAdditional(item.id)
                          setLoading(false)
                        }
                      })
                    },
                    path: '',
                    title: 'Excluir item',
                  },
                ]}
                color='primary'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const Opcionais: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Opcionais', path: '#', isActive: true},
        ]}
      >
        Opcionais
      </PageTitle>
      <OpcionaisContent />
    </>
  )
}

export {Opcionais}
